import { FixedType } from 'rc-table/lib/interface';
import { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { FoxColumnType } from '../contracts/table';
/**
 * Returns filtered ColumnType<Record<string, any>>[] based on the column's "fixed" property.
 * @param columns The columns to be filtered
 * @param fixedPosition Optional position to filter columns on
 * @example
 * const columns = [{id: 0, fixed: 'left'},{id: 1, fixed: 'right'}, {id: 2, fixed: undefined}]
 * const leftColumns = filterColumnsForPosition(columns, 'left')
 * // leftColumns = [{id: 0, fixed: 'left'}]
 * const rightColumns = filterColumnsForPosition(columns, 'right')
 * // rightColumns = [{id: 1, fixed: 'right'}]
 * const nonFixedColumns = filterColumnsForPosition(columns)
 * // nonFixedColumns = [{id: 2, fixed: undefined}]
 */
export const filterColumnsForPosition = (columns: FoxColumnType<Record<string, any>>[], fixedPosition: FixedType = undefined) =>
	columns.filter(c => c.fixed === fixedPosition);

export const useFixedColumnStyles = (position: FixedType) => {
	const theme = useContext(ThemeContext);
	if (typeof position === 'boolean') {
		return {};
	}
	const fixedColumnStyles = {
		right: {
			boxSizing: 'content-box',
			position: 'sticky',
			borderRight: 0,
			borderBottom: 0,
			//borderLeft: `2px solid ${theme.colors.grey[400]}`,
			right: 0,
			padding: 0,
			borderLeft: 'none'
		},
		left: {
			zIndex: 1,
			borderLeft: 0,
			borderBottom: 0,
			//borderRight: `2px solid ${theme.colors.grey[400]}`,
			position: 'sticky',
			left: 0,
			padding: 0
		}
	};
	return fixedColumnStyles[position];
};

export function isHtmlElement(el: any): el is HTMLElement {
	return el.style;
}
